import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { campaignsApi } from "../../api/campaigns";
import { useAuth } from "../../hooks/useAuth";

export const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const { data: stats, isLoading } = useQuery({
    queryKey: ["stats"],
    queryFn: campaignsApi.getStats,
  });

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <nav className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-primary">Naef</h1>
              <span className="ml-4 text-gray-600">Admin Dashboard</span>
            </div>
            <div className="flex space-x-4">
              <button onClick={() => navigate("/admin/settings")} className="btn btn-secondary">
                Settings
              </button>
              <button onClick={handleLogout} className="btn btn-secondary">
                Logout
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <button onClick={() => navigate("/admin/create-campaign")} className="btn btn-primary">
            Create New Campaign
          </button>
        </div>

        {isLoading ? (
          <div className="text-center py-12">
            <p className="text-xl text-gray-600">Loading statistics...</p>
          </div>
        ) : stats ? (
          <div>
            <h2 className="text-2xl font-bold mb-6">Statistics</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
              <div className="card">
                <h3 className="text-gray-600 text-sm font-medium mb-2">Total Campaigns</h3>
                <p className="text-3xl font-bold text-primary">{stats.total_campaigns}</p>
              </div>
              <div className="card">
                <h3 className="text-gray-600 text-sm font-medium mb-2">Total Residents</h3>
                <p className="text-3xl font-bold">{stats.total_residents}</p>
              </div>
              <div className="card">
                <h3 className="text-gray-600 text-sm font-medium mb-2">Pending</h3>
                <p className="text-3xl font-bold text-yellow-600">{stats.pending_count}</p>
              </div>
              <div className="card">
                <h3 className="text-gray-600 text-sm font-medium mb-2">Saved</h3>
                <p className="text-3xl font-bold text-blue-600">{stats.saved_count}</p>
              </div>
              <div className="card">
                <h3 className="text-gray-600 text-sm font-medium mb-2">Completed</h3>
                <p className="text-3xl font-bold text-green-600">{stats.done_count}</p>
              </div>
            </div>

            <div className="mt-12">
              <h2 className="text-2xl font-bold mb-6">Quick Actions</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <button
                  onClick={() => navigate("/admin/create-campaign")}
                  className="card hover:shadow-lg transition-shadow cursor-pointer text-left"
                >
                  <h3 className="text-lg font-semibold mb-2">Create Campaign</h3>
                  <p className="text-gray-600">Start a new data collection campaign</p>
                </button>
                <button
                  onClick={() => navigate("/admin/settings")}
                  className="card hover:shadow-lg transition-shadow cursor-pointer text-left"
                >
                  <h3 className="text-lg font-semibold mb-2">Reminder Settings</h3>
                  <p className="text-gray-600">Configure automatic reminders</p>
                </button>
                <button
                  onClick={() => navigate("/admin/campaigns")}
                  className="card hover:shadow-lg transition-shadow cursor-pointer text-left"
                >
                  <h3 className="text-lg font-semibold mb-2">View Campaigns</h3>
                  <p className="text-gray-600">Browse all campaigns</p>
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-12">
            <p className="text-xl text-gray-600">No data available</p>
          </div>
        )}
      </div>
    </div>
  );
};
